// extracted by mini-css-extract-plugin
export default {"image":"profile-picture_image__s4oVl"};